import React from 'react'
import { Button as RippleButton } from './RippleButton'

export const ButtonRippleEffect = () => (
  <div className='h-screen w-full flex justify-center items-center bg-black text-white'>
    <RippleButton />
  </div>
)
